import MaterialTypography from '../../../components/MaterialTypography'
import DashboardLayout from '../../../layoutcontainers/DashboardLayout'
import { CardContent, CardHeader, Stack } from '@mui/material'
import AddIcon from '@mui/icons-material/Add';
import MaterialButton from '../../../components/MaterialButton';
import { useNavigate } from 'react-router-dom';
import Table from '../../../components/Table';
import { useEffect, useState } from 'react';
import DashboardFooter from '../../../layoutcontainers/DashboardLayout/components/Footer';
import { FileUpload, FilterAlt } from '@mui/icons-material';
import { deleteData, fetchData, postData } from '../../../services';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index";
import { useSnackbar } from '../../../context/popup';
import UploadFile from '../../Utils/UploadFile';
import { useLoading } from '../../../components/Loading';
import StateListFilterDialog from './components/StateListFilterDialog.js';


const StateList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();

    const currentPage = useSelector((state) => state?.generalStateStore?.currentPage);
    const rowsPerPage = useSelector((state) => state?.generalStateStore?.rowsPerPage);
    const totalPages = useSelector((state) => state?.generalStateStore?.totalPages);

    const [stateData,setStateData] = useState([]);
    const [isRefresh, setIsRefresh] = useState(false);
    const [openUploadFileDialog, setOpenUploadFileDialog] = useState(false);
    const [fileUploading, setFileUploading] = useState(false);
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const [clearFileOnSuccess, setClearFileOnSuccess] = useState(false);
    const [search, setSearch] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [filterData, setFilterData] = useState({
        isActive: "",
        countryId: "",
    });

    useEffect(() => {
        fetchStateList();
    },[isRefresh, currentPage, rowsPerPage, search])

    //List API
    const fetchStateList = async () => {
        setCircleLoading(true);
        try {
        let url = `/reference/general/state?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}&countryId=${filterData?.countryId}`
        if(filterData.isActive !== "" && filterData.isActive !== null && filterData.isActive !== undefined) {
            url += `&isActive=${filterData.isActive}`;
        }
        const response = await fetchData(url);
        if(response?.success){
            setStateData(response?.data?.items);
            dispatch(setTotalPages(response?.data?.totalPages));     
        }
        else{
            //throw error
        }
        } catch (error) {
            console.error('Error Fetching States:', error);
            showSnackbar(error?.response?.data?.message || 'Network Error', "error");
        }
        finally{
            setCircleLoading(false);
        }
    };

    //bulk file upload api function
    const handleFileUploadSuccess = async (file) => {
        setFileUploading(true)
        setUploadSuccess(false)

        try {
            const formData = new FormData()

            formData.append('file', file)

            const result = await postData(`/reference/master/bulkUpload/general-state`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });        

            if (result?.success) {
                setUploadSuccess(true)
                showSnackbar(result?.message,"success");
                setOpenUploadFileDialog(false);
                setClearFileOnSuccess(true);
                fetchStateList(); 
            }
            else {
                setUploadSuccess(false);
                showSnackbar('Faiiled to upload file', "error")
            }

        } catch (error) {
                const errorMessage = error?.response?.data?.message;                
                console.error('Upload error:', error || errorMessage)
                showSnackbar(errorMessage, "error")
        } 
        finally {
                setFileUploading(false)
        }
    };

    //delete api function
    const handleDelete = async (row) => {
        try {
            const response = await deleteData(`/reference/general/state-delete`, {ids:[row?.id]});
            setIsRefresh(!isRefresh);
            if(response?.success){
                showSnackbar(response?.message, "success");
            }
            else{
                showSnackbar(response?.message, "error");
            }
        } catch (error) {
            console.error("Error deleting data:", error);
            showSnackbar(error?.response?.data?.message, "error");
        }
    };

    //Table Mapping
    const stateListTable = {
        columns: [
            {
            key: "sno",
            label: "S.No.",
            renderCell: (row) => row.sno,
            },
            {
            key: "name",
            label: "State Name",
            renderCell: (row) => row.name,
            },
            {
            key: "code",
            label: "Code",
            renderCell: (row) => row.code,
            },
            {
            key: "displayName",
            label: "Display Name",
            renderCell: (row) => row.displayName,
            },
            {
            key: "country",
            label: "Country",
            renderCell: (row) => row.country,
            },
            {
            key: "createdAt",
            label: "Created At",
            renderCell: (row) => row.createdAt,
            },
            {
                key: "isActive",
                label: "Status",
                renderCell: (row) => (
                    <span>
                    {row.isActive ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
                    ) : (
                        <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
                    )}
                    </span>
                )
            },
        ],
        rows: stateData?.map((state, index) => ({
            id: state?.id,
            sno: index + 1,
            name: state?.name || "",
            code: state?.code || "",
            displayName: state?.displayName || "",
            country: state?.country?.displayName || "",
            isActive: state?.isActive,
            createdAt: new Date(state?.createdAt).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            }),
        })),
    };
 
    const actions = {
        edit: true,
        view: true,
        delete: true,

        onEdit: (row) => {
            navigate(`/general-master/state-list/state-details?pageType=edit&id=${row.id}`);
        },
        onView: (row) => {
            navigate(`/general-master/state-list/state-details?pageType=view&id=${row.id}`);
        },
        onDelete: (row) => handleDelete(row),
    };

    //Handle Click Add State
    const handleAddNewState = () => {
        navigate(`/general-master/state-list/state-details`);
    };

    const handlePaginationChange = (page) => {
        dispatch(setCurrentPage(page));
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        dispatch(setRowsPerPage(rowsPerPage));
        dispatch(setCurrentPage(1));
    };

    const handleSearch = (value) => {
        setSearch(value);
    };
    
  return (
    <>
        <DashboardLayout>
            <CardHeader title={(
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                >
                    <Stack direction="column" spacing={0}>
                        <MaterialTypography variant="h5" fontWeight="medium">
                            State List
                        </MaterialTypography>
                        <MaterialTypography variant="caption" color="text">
                            List of States around the world.
                        </MaterialTypography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                        <MaterialButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        startIcon={<FilterAlt/>}
                        onClick={(event) => setAnchorEl(event.currentTarget)}    
                        >
                            Filter
                        </MaterialButton>
                        <MaterialButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        startIcon={<FileUpload/>}
                        onClick={() => setOpenUploadFileDialog(true)}>
                            Bulk Upload
                        </MaterialButton>
                        <MaterialButton

                            variant="gradient"
                            color="dark"
                            size="small"
                            startIcon={<AddIcon />}
                            onClick={() => handleAddNewState()}
                        >
                            State
                        </MaterialButton>
                    </Stack>
                </Stack>
            )} 
            />
            <CardContent>
                <Table
                columns={stateListTable?.columns}
                data={stateListTable?.rows}
                actions={actions}
                pagination={{
                    totalPages,
                    currentPage,
                    onPageChange: (page) => handlePaginationChange(page),
                    rowsPerPage,
                    onRowsPerPageChange: (rowsPerPage) => handleRowsPerPageChange(rowsPerPage),
                    rowsPerPageOptions: [5, 10, 15, 20],
                }}
                getRowKey={(row) => row.id}
                className="custom-table"
                noDataLabel="No States found"
                handleSearch={handleSearch}
                />                
            </CardContent>
            <UploadFile
            open={openUploadFileDialog}
            setOpen={setOpenUploadFileDialog}
            onUploadSuccess={handleFileUploadSuccess}
            fileTypes={['csv', 'xlsx']}
            fileUploading={fileUploading}
            uploadSuccess={uploadSuccess}
            setUploadSuccess={setUploadSuccess}
            setFileUploading={setFileUploading}
            clearFileOnSuccess={clearFileOnSuccess}
            />
            <StateListFilterDialog
            anchorEl={anchorEl}
            open={open}
            onClose={() => setAnchorEl(null)}
            filterData={filterData}
            setFilterData={setFilterData}
            onApply={() => {
                setAnchorEl(null);   // close popup
                fetchStateList();  // call API after filter applied
            }}
            />
        </DashboardLayout>
        <DashboardFooter/>
    </>
  )
}

export default StateList